<div class="row">
    <div class="col-sm-12">
        <div class="content-header p-2"><h3>{{settings?.appName}}</h3></div>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <app-image *ngIf="downloadURL" [imgClass]="'media-object d-flex mr-2 ml-1'" [downloadURL]="downloadURL" [width]="960" [height]="383"></app-image>
        <div class="card">
            <div class="card-header pb-0">
                <h2 class="m-0"><span *ngIf="reply && reply.id">Antwort für: </span>{{message?.title}}</h2>
            </div>
            <div class="card-footer" style="font-size: 120%;">
                Um den gesamten Chatverlauf einzusehen oder zu antworten, <a [routerLink]="['/messages', message.id]">loggen Sie sich bitte ein</a>
            </div>
            <div class="card-body p-3">
                <b>Von: {{message?.user?.name}}</b>
                <div *ngIf="message.textDelta | richText as richHtml; else plainMessageText" class="rt" [innerHtml]="richHtml"></div>
                <ng-template #plainMessageText><p [innerHtml]="message.text | newline"></p></ng-template>
            </div>
            <div class="card-body p-3" *ngIf="reply && reply.id">
                <b>Antwort von: {{reply?.user?.name}}</b>
                <p [innerHtml]="reply.text | newline"></p>
            </div>
            <div class="card-body p-3" *ngIf="message.category; else elseBlock1">
                <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
            </div>
            <ng-template #elseBlock1>
                <div class="card-body p-3" *ngIf="message.audio; else elseBlock2">
                    <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
                </div>
                <ng-template #elseBlock2>
                    <div class="card-body p-3" *ngIf="message.image; else elseBlock3">
                        <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
                    </div>
                    <ng-template #elseBlock3>
                        <div class="card-body p-3" *ngIf="message.document; else elseBlock4">
                            <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
                        </div>
                        <ng-template #elseBlock4>
                            <div class="card-body p-3" *ngIf="message.images && message.images.length; else elseBlock5">
                                <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
                            </div>
                            <ng-template #elseBlock5>
                                <div class="card-body p-3" *ngIf="message.documents && message.documents.length">
                                    <b>Diese Nachricht enthält Anhänge. Bitte loggen Sie sich ein, um diese einzusehen.</b>
                                </div>
                            </ng-template>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>
            <div class="card-footer" style="font-size: 120%;">
                Um den gesamten Chatverlauf einzusehen oder zu antworten, <a [routerLink]="['/messages', message.id]">loggen Sie sich bitte ein</a>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/messages/message-detail/message-detail.component.html